import React, { useState, useEffect, useRef, useMemo } from "react";

/* ============================================================
   CONFIG — placeholders, swap these before going live
   ============================================================ */
const API_BASE = "https://myibh.in/api";
const RAZORPAY_KEY_ID = "rzp_live_TEE5TqllZDQPRF"; // TODO: replace with real Key ID from Razorpay dashboard
const RAZORPAY_CHECKOUT_SRC = "https://checkout.razorpay.com/v1/checkout.js";
// TODO: once you upload the skyline photos, set these to the image URLs/paths.
// Until then, a lightweight illustrated skyline is shown automatically.
const HERO_IMAGES = {
  choice: "/Event/pexels-asia-culture-center-3116378-5026349.avif",
  eventTier: "/Event/ChatGPT Image Jul 10, 2026, 06_41_33 PM.avif",
  pitchTier: "/Event/pexels-pavel-danilyuk-8761324.avif",
  audienceTier: "/Event/audienceTier.avif",
  form: "/Event/pexels-polina-tankilevitch-6928872.avif",
};
const LINK_BLUE = "#3866e0";

/* ============================================================
   FONT AWESOME — CDN loader (injects the stylesheet once)
   ============================================================ */
const FA_CDN_HREF = "https://cdnjs.cloudflare.com/ajax/libs/font-awesome/6.5.1/css/all.min.css";
if (typeof document !== "undefined" && !document.getElementById("rm-fa-cdn-link")) {
  const link = document.createElement("link");
  link.id = "rm-fa-cdn-link";
  link.rel = "stylesheet";
  link.href = FA_CDN_HREF;
  document.head.appendChild(link);
}

/* ── EVENT REGISTRATION — Early Bird / Passion / Regular / General / Business / VIP / All Access ── */
const EVENT_TIER_CONFIGS = [
  // {
  //   key: "early_bird",
  //   label: "Early Bird Pass",
  //   price: 399,
  //   features: ["Access to all keynote sessions", "Networking tea and refreshment breaks", "Delegate kit with IBH Merchandise", "Hi-tea"],
  
  //   featureStyle: "list",
  //   icon: "fa-ticket",
  //   accent: "#c9a227",
  //   soft: "#f6ecc8",
  //   forceSoldOut: true,
  // },
  // {
  //   key: "passion",
  //   label: "Passion Pass",
  //   price: 499,
  //   features: ["Access to all keynote sessions", "Networking tea and refreshment breaks", "Delegate kit with IBH Merchandise", "Hi-tea"],
    
  //   featureStyle: "list",
  //   icon: "fa-ticket",
  //   accent: "#b8860b",
  //   soft: "#f0dfa0",
  //   forceSoldOut: true,
  // },
  // {
  //   key: "regular",
  //   label: "Regular Pass",
  //   price: 599,
  //   features: ["Access to all keynote sessions", "Networking tea and refreshment breaks", "Delegate kit with IBH Merchandise", "Hi-tea"],
  
  //   featureStyle: "list",
  //   icon: "fa-ticket",
  //   accent: "#c9a227",
  //   soft: "#f6ecc8",
  //   forceSoldOut: true,
  // },
  // {
  //   key: "general",
  //   label: "General Pass",
  //   price: 999,
  //   totalSlots: 148,
  //   tagline: "For aspiring entrepreneurs, professionals & students",
  //   features: ["Access to all keynote sessions", "Networking tea and refreshment breaks", "Delegate kit with IBH Merchandise", "Hi-tea"],
    
  //   featureStyle: "list",
  //   description: "Access to all keynote sessions",
  //   icon: "fa-ticket",
  //   accent: "#f37c23",
  //   soft: "#fdebd6",
  // },
  {
    key: "business",
    label: "Business Pass",
    price: 1499,
    totalSlots: 125,
    tagline: "Best for founders, MSMEs & business owners",
    features: ["Priority seating in the Reserved Business Zone", "Access to the exclusive Business Networking Meetup", "Investor Pitch Viewing Session", "Startup Showcase access", "1-month exclusive IBH Leadership Community membership", "Digital Delegate Directory (post-event access)"],
    featureStyle: "list",
    description: "Priority seating & business networking access",
    icon: "fa-briefcase",
    accent: "#002a9b",
    soft: "#e2e7f7",
  },
  {
    key: "vip",
    label: "VIP Pass",
    price: 2499,
    totalSlots: 136,
    tagline: "Best for CXOs, Investors, Founders & Industry Leaders",
    features: ["Includes everything in the Business Pass", "Access to all sessions with front-row engagement", "Meet & Greet with keynote speakers", "Premium Delegate kit with IBH Merchandise", "3-month exclusive IBH Leadership Community membership", "Early access to future IBH events"],
    featureStyle: "list",
    description: "Front-row access & meet the keynote speakers",
    icon: "fa-crown",
    accent: "#00a000",
    soft: "#ddf3dd",
    highlight: true,
  },
  // {
  //   key: "All Access",
  //   label: "All Access Pass",
  //   price: 2999,
  //   totalSlots: 25,
  //   features: ["Includes everything in the Business Pass", "Dedicated pitch slot in the Startup Pitching Session", "Networking opportunities with founders and investors", "Access to 100 Crores Startup Pitch Pool"],
  //   featureStyle: "list",
  //   description: "Showcase your brand to 500+ delegates",
  //   icon: "fa-store",
  //   accent: "#8a2be2",
  //   soft: "#f0e6fb",
    
  // },
];

/* ── STARTUP PITCHING REGISTRATION — Student / Other ── */
const PITCH_TIER_CONFIGS = [
  {
    key: "student",
    label: "Student Pitch Pass",
    price: 499,
    tagline: "For students pitching their startup idea",
    features: ["Student Pass delegate kit with badge", "Networking opportunities with founders and investors", "Access to 100 Crores Startup Pitch Pool"],
    featureStyle: "list",
    description: "Access to Startup Pitching Session",
    icon: "fa-id-card",
    accent: "#3866e0",
    soft: "#e2e7f7",
  },
  {
    key: "other",
    label: "General Pitch Pass",
    price: 999,
    tagline: "For founders & professionals pitching their startup",
    features: ["General Pass delegate kit with badge", "Networking opportunities with founders and investors", "Access to 100 Crores Startup Pitch Pool"],
    featureStyle: "list",
    description: "Access to Startup Pitching Session",
    icon: "fa-briefcase",
    accent: "#f37c23",
    soft: "#fdebd6",
    highlight: true,
  },
  {
    key: "All Access",
    label: "All Access Pass",
    price: 2999,
    tagline: "For Startup Pitching Session & Event Registration Combined",
    features: ["Includes everything in the Business Pass (Event Registration)", "Dedicated pitch slot in the Startup Pitching Session", "Networking opportunities with founders and investors", "Access to 100 Crores Startup Pitch Pool"],
    featureStyle: "list",
    description: "Showcase your brand to 500+ delegates",
    icon: "fa-store",
    accent: "#8a2be2",
    soft: "#f0e6fb",
    
  },
];

/* ── AUDIENCE REGISTRATION — Early Bird / Normal Bird / Late Bird ──
   For people who just want to watch the Startup Pitching Session
   (no pitching, no pitch deck, no ID card upload). */
const AUDIENCE_TIER_CONFIGS = [
  {
    key: "early_bird",
    label: "Early Bird Pass",
    price: 399,
    totalSlots: 150,
    tagline: "Perfect for entrepreneurs, professionals & aspiring founders.",
    urgencyNote: "Limited seats. Register before prices go up",
    features: ["Live Startup Pitch Showcase Access","Curated Networking Breaks with Refreshments", "Certificate of attendance"],
    featureStyle: "list",
    description: "Watch live pitches at the best price",
    icon: "fa-users",
    accent: "#00a000",
    soft: "#ddf3dd",
  },
  // {
  //   key: "normal_bird",
  //   label: "Normal Bird Pass",
  //   price: 499,
  //   tagline: "Standard entry to the Startup Pitching Session",
  //   features: ["Access to the Startup Pitching Session", "Reserved audience seating", "Networking tea and refreshment breaks", "Digital certificate of attendance"],
  //   featureStyle: "list",
  //   description: "Watch live pitches & meet founders",
  //   icon: "fa-users",
  //   accent: "#3866e0",
  //   soft: "#e2e7f7",
  // },
  // {
  //   key: "late_bird",
  //   label: "Late Bird Pass",
  //   price: 599,
  //   tagline: "For last-minute registrations",
  //   features: ["Access to the Startup Pitching Session", "General audience seating", "Networking tea and refreshment breaks", "Digital certificate of attendance"],
  //   featureStyle: "list",
  //   description: "Secure your seat at the last minute",
  //   icon: "fa-users",
  //   accent: "#f37c23",
  //   soft: "#fdebd6",
  // },
];

const FIELD_CONFIGS = [
  { key: "full_name",    label: "Full Name",       placeholder: "Enter your full name",   required: true,  type: "text",  half: false, icon: "fa-user"     },
  { key: "email",        label: "Email Address",   placeholder: "you@example.com",        required: true,  type: "email", half: false, icon: "fa-envelope"     },
  { key: "phone",        label: "Phone Number",    placeholder: "98765 43210",            required: true,  type: "tel",   half: true,  icon: "fa-phone", isPhone: true },
  { key: "city",         label: "City",            placeholder: "e.g. Kolkata",           required: true,  type: "text",  half: true,  icon: "fa-location-dot"      },
  { key: "organization", label: "Organisation",    placeholder: "Company / Startup name", required: false, type: "text",  half: true,  icon: "fa-building" },
  { key: "designation",  label: "Designation",     placeholder: "e.g. Founder & CEO",     required: false, type: "text",  half: true,  icon: "fa-id-card"   },
];
const INITIAL = { full_name: "", email: "", phone: "", city: "", organization: "", designation: "" };

/* ============================================================
   ICONS — Font Awesome (fa-solid). `name` accepts either the new
   "fa-xxx" keys used in this file, or the legacy bare keys (e.g.
   "phone", "mail", "x") still used by RegisterModal.jsx, so nothing
   breaks outside this file.
   ============================================================ */
const FA_ICON_MAP = {
  // new-style keys (use these going forward, e.g. icon: "fa-handshake")
  "fa-ticket": "fa-ticket",
  "fa-briefcase": "fa-briefcase",
  "fa-crown": "fa-crown",
  "fa-users": "fa-users",
  "fa-star": "fa-star",
  "fa-envelope": "fa-envelope",
  "fa-phone": "fa-phone",
  "fa-location-dot": "fa-location-dot",
  "fa-building": "fa-building",
  "fa-id-card": "fa-id-card",
  "fa-shield-halved": "fa-shield-halved",
  "fa-check": "fa-check",
  "fa-circle-check": "fa-circle-check",
  "fa-arrow-right": "fa-arrow-right",
  "fa-chevron-left": "fa-chevron-left",
  "fa-xmark": "fa-xmark",
  "fa-calendar-days": "fa-calendar-days",
  "fa-clock": "fa-clock",
  "fa-store": "fa-store",
  "fa-rocket": "fa-rocket",
  "fa-lightbulb": "fa-lightbulb",
  "fa-diagram-project": "fa-diagram-project",
  "fa-handshake": "fa-handshake",
  "fa-bullhorn": "fa-bullhorn",
  "fa-medal": "fa-medal",
  "fa-gift": "fa-gift",
  "fa-arrow-trend-up": "fa-arrow-trend-up",
  "fa-lock": "fa-lock",
  "fa-bolt": "fa-bolt",
  "fa-user": "fa-user",
  "fa-file-pdf": "fa-file-pdf",
  "fa-eye": "fa-eye",
  "fa-comment-dots": "fa-comment-dots",

  // legacy keys (still used by RegisterModal.jsx) — mapped to the same FA icons
  ticket: "fa-ticket",
  briefcase: "fa-briefcase",
  crown: "fa-crown",
  users: "fa-users",
  star: "fa-star",
  mail: "fa-envelope",
  phone: "fa-phone",
  pin: "fa-location-dot",
  building: "fa-building",
  idcard: "fa-id-card",
  shield: "fa-shield-halved",
  check: "fa-check",
  checkCircle: "fa-circle-check",
  arrowRight: "fa-arrow-right",
  chevronLeft: "fa-chevron-left",
  x: "fa-xmark",
  calendar: "fa-calendar-days",
  clock: "fa-clock",
  store: "fa-store",
  rocket: "fa-rocket",
  lightbulb: "fa-lightbulb",
  network: "fa-diagram-project",
  handshake: "fa-handshake",
  megaphone: "fa-bullhorn",
  medal: "fa-medal",
  gift: "fa-gift",
  trendUp: "fa-arrow-trend-up",
  lock: "fa-lock",
  bolt: "fa-bolt",
  user: "fa-user",
  filePdf: "fa-file-pdf",
  eye: "fa-eye",
  comment: "fa-comment-dots",
};

function Icon({ name, size = 16, className, style, gradient }) {
  const resolved = FA_ICON_MAP[name] || name;
  const baseStyle = {
    fontSize: size,
    width: size,
    height: size,
    display: "inline-flex",
    alignItems: "center",
    justifyContent: "center",
    lineHeight: 1,
    flexShrink: 0,
    ...style,
  };
  if (gradient) {
    return (
      <i
        className={`fa-solid ${resolved}${className ? ` ${className}` : ""}`}
        style={{
          ...baseStyle,
          background: "linear-gradient(90deg, #f37c23, #ffd93d)",
          WebkitBackgroundClip: "text",
          backgroundClip: "text",
          color: "transparent",
        }}
        aria-hidden="true"
      />
    );
  }
  return (
    <i
      className={`fa-solid ${resolved}${className ? ` ${className}` : ""}`}
      style={baseStyle}
      aria-hidden="true"
    />
  );
}

/* ============================================================
   DECORATIVE SKYLINE PLACEHOLDERS (shown until real photos are wired up)
   ============================================================ */
function BridgeSkyline() {
  return (
    <svg viewBox="0 0 400 220" preserveAspectRatio="xMidYMax slice" style={{ width: "100%", height: "100%" }}>
      <defs>
        <radialGradient id="rm-glow-bridge" cx="72%" cy="88%" r="65%">
          <stop offset="0%" stopColor="#f37c23" stopOpacity="0.55" />
          <stop offset="100%" stopColor="#f37c23" stopOpacity="0" />
        </radialGradient>
      </defs>
      <rect width="400" height="220" fill="url(#rm-glow-bridge)" />
      <path d="M120 205 L120 35 M280 205 L280 35" stroke="rgba(255,255,255,0.32)" strokeWidth="4" />
      <path d="M30 205 Q120 55 200 125 Q280 55 370 205" stroke="rgba(255,255,255,0.28)" strokeWidth="2" fill="none" />
      <path d="M50 205 Q120 85 200 145 Q280 85 350 205" stroke="rgba(255,255,255,0.18)" strokeWidth="2" fill="none" />
      <rect x="15" y="202" width="370" height="6" fill="rgba(255,255,255,0.22)" />
      <path d="M70 55 q6 -8 12 0 q6 -8 12 0" stroke="rgba(255,255,255,0.4)" strokeWidth="2" fill="none" strokeLinecap="round" />
      <path d="M105 40 q5 -7 10 0 q5 -7 10 0" stroke="rgba(255,255,255,0.28)" strokeWidth="2" fill="none" strokeLinecap="round" />
    </svg>
  );
}
function DomeSkyline() {
  return (
    <svg viewBox="0 0 400 220" preserveAspectRatio="xMidYMax slice" style={{ width: "100%", height: "100%" }}>
      <path d="M232 205 L232 122 A48 48 0 0 1 328 122 L328 205 Z" fill="rgba(255,255,255,0.12)" />
      <circle cx="280" cy="108" r="9" fill="rgba(255,255,255,0.2)" />
      <rect x="222" y="205" width="118" height="8" fill="rgba(255,255,255,0.18)" />
      <rect x="244" y="155" width="9" height="48" fill="rgba(255,255,255,0.10)" />
      <rect x="307" y="155" width="9" height="48" fill="rgba(255,255,255,0.10)" />
      <rect x="195" y="165" width="8" height="40" fill="rgba(255,255,255,0.12)" />
      <circle cx="199" cy="162" r="5" fill="rgba(255,255,255,0.16)" />
      <rect x="357" y="165" width="8" height="40" fill="rgba(255,255,255,0.12)" />
      <circle cx="361" cy="162" r="5" fill="rgba(255,255,255,0.16)" />
    </svg>
  );
}
function SkylineRibbon() {
  return (
    <svg viewBox="0 0 400 220" preserveAspectRatio="xMidYMax slice" style={{ width: "100%", height: "100%" }}>
      <defs>
        <radialGradient id="rm-glow-ribbon" cx="30%" cy="85%" r="65%">
          <stop offset="0%" stopColor="#00a000" stopOpacity="0.45" />
          <stop offset="100%" stopColor="#00a000" stopOpacity="0" />
        </radialGradient>
      </defs>
      <rect width="400" height="220" fill="url(#rm-glow-ribbon)" />
      <rect x="40" y="120" width="26" height="90" fill="rgba(255,255,255,0.14)" />
      <rect x="80" y="90" width="30" height="120" fill="rgba(255,255,255,0.18)" />
      <rect x="124" y="140" width="22" height="70" fill="rgba(255,255,255,0.12)" />
      <rect x="160" y="70" width="34" height="140" fill="rgba(255,255,255,0.2)" />
      <rect x="208" y="110" width="24" height="100" fill="rgba(255,255,255,0.14)" />
      <rect x="246" y="95" width="28" height="115" fill="rgba(255,255,255,0.18)" />
      <path d="M20 205 Q200 175 380 205" stroke="rgba(255,255,255,0.3)" strokeWidth="2" fill="none" />
    </svg>
  );
}
function DomeSkylineLines() {
  return (
    <g fill="none" stroke="#0d1433" strokeWidth="1.4">
      <path d="M0 210 L400 210" />
      <path d="M40 210 V150 L60 130 L80 150 V210" />
      <path d="M100 210 V120 H140 V210" />
      <circle cx="120" cy="105" r="14" />
      <path d="M120 91 V70" />
      <path d="M160 210 V160 L190 130 A30 30 0 0 1 220 160 V210" />
      <path d="M250 210 V140 H270 V210 M260 140 V115" />
      <path d="M300 210 V170 H330 V210" />
      <path d="M20 210 V190 H35 V210" />
    </g>
  );
}
const HERO_FALLBACKS = {
  choice: BridgeSkyline,
  eventTier: BridgeSkyline,
  pitchTier: SkylineRibbon,
  audienceTier: DomeSkyline,
  form: DomeSkyline,
};

/* ── Golden glowy particle animation, overlaid on top of the hero art ── */
function HeroParticles({ count = 18 }) {
  const particles = useMemo(() => {
    const arr = [];
    for (let i = 0; i < count; i++) {
      arr.push({
        id: i,
        top: Math.random() * 90 + "%",
        left: Math.random() * 96 + "%",
        size: Math.round(Math.random() * 2 + 1.5), // 1.5px – 3.5px
        delay: (Math.random() * 3).toFixed(2) + "s",
        duration: (Math.random() * 2 + 2.5).toFixed(2) + "s",
      });
    }
    return arr;
  }, [count]);
  return (
    <div className="rm-hero-particles" aria-hidden="true">
      {particles.map((p) => (
        <span
          key={p.id}
          className="rm-hero-particle"
          style={{
            top: p.top,
            left: p.left,
            width: p.size,
            height: p.size,
            animationDelay: p.delay,
            animationDuration: p.duration,
          }}
        />
      ))}
    </div>
  );
}

function HeroBackdrop({ variant, particles = false }) {
  const src = HERO_IMAGES[variant];
  const Fallback = HERO_FALLBACKS[variant] || BridgeSkyline;
  const isPitch = variant === "pitchTier";
  return (
    <div className="rm-hero-bg">
      {src ? (
        <img
          src={src}
          alt=""
        
        />
      ) : (
        <Fallback />
      )}
      <div className="rm-hero-overlay" />
      {particles && <HeroParticles />}
    </div>
  );
}

/* Dark pill-style meta row rendered inside the hero (tier + form steps) */
function HeroMetaPills({ items }) {
  return (
    <div className="rm-hero-pills">
      {items.map((item, i) => (
        <span className="rm-hero-pill" key={i}>
          <Icon name={item.icon} size={13} />
          {item.text}
        </span>
      ))}
    </div>
  );
}

/* Light two-line meta card rendered below the hero (choice step only) */
function MetaCardLight({ items }) {
  return (
    <div className="rm-meta-strip-light">
      {items.map((item, i) => (
        <React.Fragment key={i}>
          {i > 0 && <span className="rm-meta-divider-v" />}
          <div className="rm-meta-item-light2">
            <span className="rm-meta-item-light2-icon"><Icon name={item.icon} size={15} /></span>
            <span>
              <strong>{item.line1}</strong>
              <small>{item.line2}</small>
            </span>
          </div>
        </React.Fragment>
      ))}
    </div>
  );
}

function Divider({ children }) {
  return (
    <div className="rm-divider">
      <span className="rm-divider-dot" />
      <span className="rm-divider-line" />
      <span className="rm-divider-text">{children}</span>
      <span className="rm-divider-line" />
      <span className="rm-divider-dot" />
    </div>
  );
}

/* ============================================================
   SLOT AVAILABILITY (for capped tiers: General, Business, VIP, All Access)
   ============================================================ */
function useSlotAvailability(tierKey, total) {
  const [state, setState] = useState({ remaining: total, loading: !!total });
  useEffect(() => {
    if (!total) return;
    let cancelled = false;
    fetch(`${API_BASE}/slot-availability.php?type=${encodeURIComponent(tierKey)}`)
      .then((res) => res.json())
      .then((data) => {
        if (cancelled) return;
        if (data && typeof data.remaining === "number") {
          setState({ remaining: data.remaining, loading: false });
        } else {
          setState({ remaining: total, loading: false });
        }
      })
      .catch(() => {
        if (!cancelled) setState({ remaining: total, loading: false });
      });
    return () => { cancelled = true; };
  }, [tierKey, total]);
  return state;
}

/* ============================================================
   STYLES
   ============================================================ */
const modalStyles = `
 .rm-overlay {
  position: fixed;
  inset: 0;
  height: 100vh;
  height: 100dvh; /* real visible viewport on mobile, avoids address-bar mismatch */
  background: radial-gradient(circle at 8% 8%, rgba(243,124,35,0.14), transparent 42%),
              radial-gradient(circle at 96% 26%, rgba(56,102,224,0.16), transparent 48%),
              radial-gradient(circle at 20% 90%, rgba(0,160,0,0.08), transparent 40%),
              #eef1fb;
  z-index: 9000;
  display: flex;
  align-items: flex-start;
  justify-content: stretch;
  padding: 0;
  animation: rm-fade-in 0.2s ease;
  overflow-y: auto;
  overflow-x: hidden;
  -webkit-overflow-scrolling: touch;
}
  .rm-overlay::-webkit-scrollbar { display: none; }
.rm-overlay { scrollbar-width: none; }
    .rm-hero-wrap.rm-anchor-bottom {
  display: flex;
  flex-direction: column;
  justify-content: flex-end;
}
.rm-hero-wrap.rm-anchor-bottom .rm-header {
  position: static;   /* so Back/Close re-anchor to the hero-wrap, not the header */
  margin-top: auto;
}
  .rm-bg-watermark {
    position: fixed;
    bottom: -40px;
    width: 480px;
    height: 420px;
    opacity: 0.15;
    pointer-events: none;
    z-index: 0;
    object-fit: cover;
    border-radius: 24px;
  }
  .rm-bg-watermark.left { left: -80px; }
  .rm-bg-watermark.right { right: -80px; }
  .rm-modal { position: relative; z-index: 1; }
  * { box-sizing: border-box; }
  @keyframes rm-fade-in { from { opacity: 0; } to { opacity: 1; } }
  @keyframes rm-slide-up {
    from { opacity: 0; transform: translateY(24px); }
    to   { opacity: 1; transform: translateY(0);    }
  }
.rm-modal {
  background: transparent;
  border-radius: 0;
  width: 100vw;
  max-width: 100vw;
  min-height: 100%;
  overflow: visible; /* overlay is now the scroll container, not this */
  box-shadow: none;
  animation: rm-slide-up 0.28s cubic-bezier(.22,.68,0,1.2);
  font-family: 'Inter', sans-serif;
  display: flex;
  flex-direction: column;
}
  .rm-modal::-webkit-scrollbar { display: none; }
  /* ── Hero header — contained card so the skyline art shows in full ── */
 .rm-hero-wrap {
  position: relative;
  overflow: hidden;
  border-radius: 28px;
  background:
    radial-gradient(ellipse 70% 100% at -5% -5%, rgba(255,140,30,0.60) 0%, rgba(255,160,60,0.25) 35%, transparent 60%),
    radial-gradient(ellipse 60% 80% at 105% 110%, rgba(10,120,10,0.55) 0%, rgba(19,136,8,0.20) 35%, transparent 60%),
    #ffffff;
  flex-shrink: 0;
  margin: 28px auto 0;
  width: calc(100% - 56px);
  max-width: 1180px;
  min-height: 300px;
  box-shadow: 0 24px 60px rgba(13,20,51,0.28);
  box-sizing: border-box;
}
  /* ── Golden glowy particles overlay ── */
  .rm-hero-particles {
    position: absolute;
    inset: 0;
    z-index: 1;
    pointer-events: none;
  }
  .rm-hero-particle {
    position: absolute;
    border-radius: 50%;
    background: #ffd93d;
    box-shadow: 0 0 6px 2px rgba(255,217,61,0.7);
    animation-name: rm-twinkle;
    animation-timing-function: ease-in-out;
    animation-iteration-count: infinite;
  }
  @keyframes rm-twinkle {
    0%, 100% { opacity: 0.15; transform: scale(0.7) translateY(0); }
    50% { opacity: 1; transform: scale(1.3) translateY(-4px); }
  }
  .rm-hero-bg { position: absolute; inset: 0; }
  .rm-hero-bg img { width: 100%; height: 100%; object-fit: cover; object-position: 0% 50%; }
.rm-hero-overlay {
  position: absolute; inset: 0;
  background: linear-gradient(100deg, rgba(13,20,51,0.82) 32%, rgba(13,20,51,0.5) 58%, rgba(13,20,51,0.1) 100%);
}
  .rm-header { position: relative; z-index: 2; padding: 32px 44px 30px; max-width: 1040px; margin: 0 auto; width: 100%; box-sizing: border-box; }
  .rm-header-plain { background: #0d1433; border-radius: 0; }
  .rm-header-badge {
    display: inline-flex;
    align-items: center;
    gap: 8px;
    background: rgba(243,124,35,0.18);
    border: 1px solid rgba(243,124,35,0.35);
    border-radius: 50px;
    padding: 5px 14px;
    font-size: 10px;
    font-weight: 700;
    letter-spacing: 1.5px;
    color: #f8f8f7;
    text-transform: uppercase;
    margin-bottom: 12px;
  }
  .rm-header-badge.rm-with-back { margin-top: 34px; }
  .rm-header h2 {
    font-family: 'Poppins', sans-serif;
    font-size: 1.85rem;
    font-weight: 800;
    color: #fff;
    margin: 0 0 8px;
    line-height: 1.2;
  }
  .rm-header h2 span {
    background: linear-gradient(90deg, #f37c23, #ffd93d);
    -webkit-background-clip: text;
    background-clip: text;
    color: transparent;
  }
  .rm-header p {
    font-size: 14px;
    color: rgba(255,255,255,0.85);
    margin: 0 0 18px;
    line-height: 1.55;
    max-width: 62%;
  }
  .rm-header-no-badge h2 { margin-top: 32px; }
  .rm-close {
    position: absolute;
    top: 24px;
    right: 28px;
    width: 36px;
    height: 36px;
    border-radius: 50%;
    background: rgba(255,255,255,0.06);
    border: 1.5px solid rgba(255,255,255,0.4);
    color: #fff;
    display: flex;
    align-items: center;
    justify-content: center;
    cursor: pointer;
    transition: background 0.2s;
    flex-shrink: 0;
    z-index: 3;
  }
  .rm-close:hover { background: rgba(255,255,255,0.18); }
  .rm-back {
    position: absolute;
    top: 24px;
    left: 28px;
    display: flex;
    align-items: center;
    gap: 6px;
    background: rgba(255,255,255,0.1);
    border: 1px solid rgba(255,255,255,0.16);
    color: #fff;
    font-size: 12px;
    font-weight: 600;
    border-radius: 50px;
    padding: 7px 14px 7px 10px;
    cursor: pointer;
    transition: background 0.2s;
    z-index: 3;
  }
  .rm-back:hover { background: rgba(255,255,255,0.2); }
  .rm-hero-pills { display: flex; align-items: center; gap: 10px; flex-wrap: wrap; }
  .rm-hero-pill {
    display: inline-flex; align-items: center; gap: 7px;
    background: rgba(255,255,255,0.08);
    border: 1px solid rgba(255,255,255,0.18);
    border-radius: 50px;
    padding: 8px 16px;
    font-size: 12.5px;
    font-weight: 600;
    color: #fff;
    white-space: nowrap;
  }
  .rm-hero-pill i { color: #f37c23; flex-shrink: 0; }
  .rm-hero-features { display: flex; align-items: flex-start; gap: 0; position: relative; z-index: 2; flex-wrap: wrap; }
  .rm-hero-feature { display: flex; flex-direction: column; align-items: center; gap: 8px; padding: 0 26px; text-align: center; }
  .rm-hero-feature:first-child { padding-left: 0; }
  .rm-hero-feature-divider { width: 1px; height: 50px; background: rgba(255,255,255,0.15); align-self: center; flex-shrink: 0; }
  .rm-hero-feature-icon {
    width: 40px; height: 40px; border-radius: 50%; flex-shrink: 0;
    display: flex; align-items: center; justify-content: center;
    background: rgba(255,255,255,0.06);
    border: 1px solid rgba(255,217,61,0.3);
  }
  .rm-hero-feature strong { display: block; font-size: 13.5px; font-weight: 700; color: #fff; text-align: center; }
  .rm-hero-feature small { display: block; font-size: 11.5px; color: rgba(255,255,255,0.55); text-align: center; }
  .rm-meta-strip-light {
    background: #fff;
    border: 1.5px solid #eceff7;
    border-radius: 16px;
    box-shadow: 0 8px 24px rgba(13,20,51,0.06);
    margin: 22px auto 4px;
    max-width: 900px;
    width: calc(100% - 120px);
    padding: 16px 30px;
    display: flex;
    align-items: center;
    justify-content: center;
    flex-wrap: wrap;
    flex-shrink: 0;
    box-sizing: border-box;
  }
  .rm-meta-item-light2 { display: flex; align-items: center; gap: 10px; padding: 4px 26px; white-space: nowrap; }
  .rm-meta-item-light2-icon {
    width: 34px; height: 34px; border-radius: 50%; flex-shrink: 0;
    display: flex; align-items: center; justify-content: center;
    background: #fdebd6; color: #f37c23;
  }
  .rm-meta-item-light2 strong { display: block; font-size: 13.5px; font-weight: 700; color: #1a1f2e; }
  .rm-meta-item-light2 small { display: block; font-size: 11.5px; color: #9aa3b8; }
  .rm-meta-divider-v { width: 1px; height: 30px; background: #eceff7; flex-shrink: 0; }
  .rm-divider { display: flex; align-items: center; gap: 10px; margin: 4px 0 18px; }
  .rm-divider-line { flex: 1; height: 1px; background: #e7e9f2; }
  .rm-divider-text { font-size: 11px; font-weight: 700; letter-spacing: 1.5px; color: #aab2c3; white-space: nowrap; }
  .rm-divider-dot { width: 6px; height: 6px; border-radius: 50%; background: #f37c23; flex-shrink: 0; }
  .rm-body { padding: 30px 44px 48px; max-width: 1040px; margin: 0 auto; width: 100%; box-sizing: border-box; }
  .rm-field-row { display: grid; grid-template-columns: 1fr 1fr; gap: 14px; margin-bottom: 14px; }
  .rm-field { display: flex; flex-direction: column; margin-bottom: 14px; }
  .rm-field:last-child { margin-bottom: 0; }
  .rm-label { font-size: 11.5px; font-weight: 700; color: #1a1f2e; letter-spacing: 0.5px; margin-bottom: 6px; text-transform: uppercase; }
  .rm-label .req { color: #f37c23; margin-left: 2px; }
  .rm-input-wrap { position: relative; display: flex; align-items: center; }
  .rm-input-icon { position: absolute; left: 13px; color: #aab2c3; pointer-events: none; }
  .rm-input {
    border: 1.5px solid #e0e4ef;
    border-radius: 10px;
    padding: 11px 14px 11px 38px;
    font-size: 14px;
    font-family: 'Inter', sans-serif;
    color: #1a1f2e;
    background: #fafbfd;
    transition: border-color 0.2s, box-shadow 0.2s;
    outline: none;
    width: 100%;
  }
  .rm-input:focus { border-color: #f37c23; box-shadow: 0 0 0 3px rgba(243,124,35,0.12); background: #fff; }
  .rm-input.error { border-color: #e53e3e; box-shadow: 0 0 0 3px rgba(229,62,62,0.10); }
  .rm-input::placeholder { color: #aab2c3; }
  .rm-error-msg { font-size: 11px; color: #e53e3e; margin-top: 4px; font-weight: 500; }
  .rm-phone-group {
    display: flex;
    border: 1.5px solid #e0e4ef;
    border-radius: 10px;
    background: #fafbfd;
    overflow: hidden;
    transition: border-color 0.2s, box-shadow 0.2s;
  }
  .rm-phone-group:focus-within { border-color: #f37c23; box-shadow: 0 0 0 3px rgba(243,124,35,0.12); background: #fff; }
  .rm-phone-group.error { border-color: #e53e3e; box-shadow: 0 0 0 3px rgba(229,62,62,0.10); }
  .rm-phone-code {
    display: flex; align-items: center; justify-content: center;
    padding: 0 12px; font-size: 14px; font-weight: 700; color: #1a1f2e;
    border-right: 1.5px solid #e0e4ef; background: #f3f4f8; flex-shrink: 0;
  }
  .rm-phone-input-wrap { position: relative; flex: 1; display: flex; align-items: center; min-width: 0; }
  .rm-phone-input-wrap .rm-input-icon { left: 12px; }
  .rm-phone-group input {
    border: none; background: transparent; outline: none; width: 100%; min-width: 0;
    padding: 11px 14px 11px 36px; font-size: 14px; font-family: 'Inter', sans-serif; color: #1a1f2e;
  }
  .rm-phone-group input::placeholder { color: #aab2c3; }
  .rm-choice-list { display: grid; grid-template-columns: repeat(3, 1fr); gap: 26px; }
  .rm-choice-card {
    position: relative;
    overflow: hidden;
    border-radius: 22px;
    padding: 30px 28px 26px; 
    cursor: pointer;
    background: rgba(255,255,255,0.55);
    backdrop-filter: blur(20px) saturate(180%);
    -webkit-backdrop-filter: blur(20px) saturate(180%);
    border: 1.5px solid var(--card-border, rgba(255,255,255,0.7));
    box-shadow: 0 8px 28px rgba(13,20,51,0.08), inset 0 1px 0 rgba(255,255,255,0.9);
    transition: box-shadow 0.2s, transform 0.15s, border-color 0.2s, background 0.2s;
    display: flex;
    flex-direction: column;
  }
  .rm-choice-card::before {
    content: "";
    position: absolute;
    top: 0; right: 0;
    width: 160px; height: 160px;
    background-image: radial-gradient(currentColor 1.4px, transparent 1.4px);
    background-size: 16px 16px;
    color: var(--card-dot, rgba(13,20,51,0.10));
    -webkit-mask-image: radial-gradient(circle at top right, #000 0%, transparent 72%);
    mask-image: radial-gradient(circle at top right, #000 0%, transparent 72%);
    pointer-events: none;
  }
  .rm-choice-card:hover {
    background: rgba(255,255,255,0.75);
    box-shadow: 0 16px 40px rgba(13,20,51,0.14), inset 0 1px 0 rgba(255,255,255,0.95);
    transform: translateY(-2px);
    border-color: var(--card-border-hover, rgba(255,255,255,0.9));
  }
  .rm-choice-tag {
    align-self: flex-start;
    font-size: 10px; font-weight: 800; letter-spacing: 1px; text-transform: uppercase;
    border-radius: 50px; padding: 4px 12px; margin-bottom: 16px;
    position: relative; z-index: 1;
  }
  .rm-choice-top { display: flex; align-items: flex-start; gap: 16px; margin-bottom: 16px; position: relative; z-index: 1; }
  .rm-choice-icon-wrap { position: relative; width: 58px; height: 58px; flex-shrink: 0; }
  .rm-choice-icon {
    position: relative; z-index: 1;
    width: 58px; height: 58px; border-radius: 50%; flex-shrink: 0;
    display: flex; align-items: center; justify-content: center;
    border: 1px solid rgba(255,255,255,0.8);
    box-shadow: inset 0 1px 0 rgba(255,255,255,0.9);
  }
  .rm-choice-main { flex: 1; min-width: 0; }
  .rm-choice-main h3 { font-family: 'Poppins', sans-serif; font-weight: 700; font-size: 18px; color: #0d1433; margin: 0 0 6px; }
  .rm-choice-main p { font-size: 13.5px; color: #5b6577; margin: 0; line-height: 1.5; }
  .rm-choice-divider { height: 1px; margin: 4px 0 18px; position: relative; z-index: 1; }
  .rm-choice-feats-row { display: flex; align-items: flex-start; justify-content: space-between; gap: 16px; position: relative; z-index: 1; flex-wrap: nowrap; }
  .rm-choice-feats { display: flex; justify-content: flex-start; gap: 14px; flex: 1; flex-wrap: wrap; min-width: 0; row-gap: 16px; column-gap: 8px;}
  .rm-choice-feat { display: flex; flex-direction: column; align-items: center; gap: 8px; text-align: center; flex: 1 1 42%; min-width: 0; }
  .rm-choice-feat i { color: var(--card-accent, #8a93a8); }
  .rm-choice-feat span { font-size: 11px; white-space: normal; font-weight: 600; color: #5b6577; line-height: 1.3; }
  .rm-choice-arrow-btn {
    position: relative;
    width: 46px; height: 46px; border-radius: 50%; border: none; cursor: pointer; flex-shrink: 0;
    display: flex; align-items: center; justify-content: center; color: #fff;
    transition: transform 0.15s, box-shadow 0.15s;
  }
  .rm-choice-card:hover .rm-choice-arrow-btn { transform: translateX(3px); }
  .rm-stats-bar {
    background: #0d1433;
    border-radius: 20px;
    margin-top: 22px;
    padding: 20px 30px;
    display: flex;
    align-items: center;
    justify-content: space-between;
    gap: 18px;
    flex-wrap: wrap;
  }
  .rm-stats-items { display: flex; align-items: center; gap: 14px; flex-wrap: nowrap; flex: 1; min-width: 0; }
  .rm-stat { display: flex; align-items: center; gap: 8px; padding-right: 14px; border-right: 1px solid rgba(255,255,255,0.12); flex: 1 1 0; min-width: 0; }
  .rm-stat:last-child { border-right: none; padding-right: 0; }
  .rm-stat-icon {
    width: clamp(32px, 4vw, 44px); height: clamp(32px, 4vw, 44px); border-radius: 50%; flex-shrink: 0;
    display: flex; align-items: center; justify-content: center;
    background: rgba(255,255,255,0.06);
    border: 1px solid rgba(255,217,61,0.3);
    box-sizing: border-box;
  }
  .rm-stat-icon i {
    display: flex !important;
    align-items: center !important;
    justify-content: center !important;
    width: 100% !important;
    height: 100% !important;
    font-size: clamp(14px, 1.8vw, 18px) !important;
    line-height: 1 !important;
  }
  .rm-hero-feature-icon i,
  .rm-choice-icon i,
  .rm-tier-icon i,
  .rm-tfd-icon i,
  .rm-details-header-icon i,
  .rm-selected-card-icon i,
  .rm-meta-item-light2-icon i,
  .rm-choice-arrow-btn i,
  .rm-success-icon i {
    display: flex !important;
    align-items: center !important;
    justify-content: center !important;
    width: 100% !important;
    height: 100% !important;
    line-height: 1 !important;
  }
  .rm-stat div { min-width: 0; }
  .rm-stat strong { display: block; font-size: clamp(12px, 1.4vw, 14.5px); font-weight: 800; color: #fff; white-space: nowrap; }
  .rm-stat span { display: block; font-size: clamp(9.5px, 1.1vw, 11px); color: rgba(255,255,255,0.55); line-height: 1.25; white-space: nowrap; }
  .rm-stats-cta {
    background: linear-gradient(90deg, #f37c23, #e0392f);
    border: none; border-radius: 14px; cursor: pointer;
    padding: 12px 22px; text-align: center; color: #fff; flex-shrink: 0;
    white-space: nowrap;
  }
  .rm-stats-cta strong { display: block; font-family: 'Poppins', sans-serif; font-size: 13.5px; font-weight: 700; }
  .rm-stats-cta span { display: block; font-size: 11px; opacity: 0.9; margin-top: 2px; }
  .rm-tier-list { display: flex; flex-direction: column; gap: 14px; }
  .rm-tier-list.rm-tier-grid-2 { display: grid; grid-template-columns: 1fr 1fr; gap: 18px; }
  .rm-tier-card {
    position: relative;
    display: flex;
    align-items: flex-start;
    gap: 18px;
    border-radius: 16px;
    padding: 22px 26px 22px 22px;
    cursor: pointer;
    background: #fff;
    border: 1.5px solid #eceff2;
    border-left: 5px solid var(--tier-accent, #ccc);
    box-shadow: 0 3px 12px rgba(13,20,51,0.05);
    transition: border-color 0.2s, box-shadow 0.2s, transform 0.15s;
  }
  .rm-tier-card:hover:not(.soldout) {
    box-shadow: 0 8px 22px rgba(13,20,51,0.09);
    transform: translateY(-1px);
  }
  .rm-tier-card.selected {
    box-shadow: 0 8px 26px rgba(13,20,51,0.10);
    background: linear-gradient(90deg, var(--tier-soft, #f7f8fb) 0%, #fff 45%);
  }
  .rm-tier-card.soldout { cursor: not-allowed; opacity: 0.55; }
  .rm-tier-radio {
    width: 22px; height: 22px; border-radius: 50%;
    border: 2px solid #d4daea; flex-shrink: 0; margin-top: 4px;
    display: flex; align-items: center; justify-content: center;
    transition: border-color 0.2s;
  }
  .rm-tier-radio-dot { width: 11px; height: 11px; border-radius: 50%; transform: scale(0); transition: transform 0.15s; }
  .rm-tier-card.selected .rm-tier-radio-dot { transform: scale(1); }
  .rm-tier-icon {
    width: 50px; height: 50px; border-radius: 50%; flex-shrink: 0;
    display: flex; align-items: center; justify-content: center;
  }
  .rm-tier-main { flex: 1; min-width: 0; position: relative; }
  .rm-tier-top { display: flex; align-items: flex-start; gap: 14px; margin-bottom: 10px; padding-right: 150px; }
  .rm-tier-title-col { display: flex; flex-direction: column; gap: 4px; flex: 1; min-width: 0; }
  .rm-tier-name { font-family: 'Poppins', sans-serif; font-weight: 700; font-size: 17.5px; color: #0d1433; display: flex; align-items: center; gap: 9px; flex-wrap: wrap; }
  .rm-tier-badge { font-size: 10px; font-weight: 800; letter-spacing: 0.5px; text-transform: uppercase; border-radius: 50px; padding: 3px 10px; }
  .rm-tier-price-wrap { position: absolute; top: 0; right: 0; display: flex; flex-direction: column; align-items: flex-end; gap: 6px; flex-shrink: 0; }
  .rm-tier-price { font-family: 'Poppins', sans-serif; font-weight: 800; font-size: 21px; white-space: nowrap; line-height: 1; }
  .rm-tier-price-note { font-size: 10.5px; color: #9aa3b8; font-weight: 500; }
  .rm-tier-select-btn {
    font-size: 11.5px; font-weight: 700; border-radius: 50px; padding: 6px 14px;
    cursor: pointer; white-space: nowrap; transition: background 0.15s;
    display: inline-flex; align-items: center; gap: 5px;
  }
  .rm-tier-tagline { font-size: 13.5px; color: #5b6577; margin: 0; line-height: 1.4; }
  .rm-tier-urgency {
    display: inline-flex;
    align-items: center;
    gap: 10px;
    background: #fdf1e4;
    border: 1.5px solid #f6cb9c;
    border-radius: 10px;
    padding: 7px 16px;
    margin: 2px 0 10px;
    font-size: 13.5px;
    font-weight: 700;
    color: #d9691a;
  }
  .rm-tier-urgency-icon {
    width: 22px; height: 22px; border-radius: 50%; flex-shrink: 0;
    background: #f37c23; color: #fff;
    display: flex; align-items: center; justify-content: center;
    font-size: 11px;
  }
  .rm-tier-feats-dots { display: flex; flex-wrap: wrap; align-items: center; gap: 8px 20px; font-size: 12.5px; color: #3d4456; font-weight: 500; }
.rm-tier-feats-dots .rm-fd-item { display: inline-flex; align-items: center; gap: 5px; }
  .rm-tier-feats-grid { display: grid; grid-template-columns: 1fr 1fr; gap: 8px 18px; }
  .rm-tier-feats-grid .rm-fg-item { display: flex; align-items: center; gap: 7px; font-size: 12.5px; color: #3d4456; font-weight: 500; }
  .rm-tier-feats-list { display: flex; flex-direction: column; gap: 9px; }
  .rm-tier-feats-list .rm-fl-item { display: flex; align-items: center; gap: 7px; font-size: 13.5px; color: #3d4456; font-weight: 500; }
  .rm-selected-card {
    display: flex; align-items: center; justify-content: space-between; gap: 16px; flex-wrap: wrap;
    border-radius: 18px; padding: 20px 24px; margin-bottom: 26px;
  }
  .rm-selected-card-left { display: flex; align-items: center; gap: 16px; }
  .rm-selected-card-icon {
    width: 52px; height: 52px; border-radius: 50%; flex-shrink: 0;
    display: flex; align-items: center; justify-content: center;
    background: rgba(255,255,255,0.85);
  }
  .rm-selected-card strong { display: block; font-family: 'Poppins', sans-serif; font-size: 16.5px; color: #0d1433; }
  .rm-selected-card .sc-desc { font-size: 12.5px; color: #6b7488; margin-top: 2px; }
  .rm-selected-card-right { display: flex; align-items: center; gap: 16px; flex-shrink: 0; }
  .rm-selected-card .sc-price { font-family: 'Poppins', sans-serif; font-weight: 800; font-size: 20px; }
  .rm-change-btn {
    background: #fff; border: 1.5px solid rgba(0,0,0,0.08); border-radius: 50px;
    font-weight: 700; font-size: 12.5px; padding: 9px 18px; cursor: pointer; white-space: nowrap;
  }
  .rm-change-btn:hover { background: #f7f8fb; }
  .rm-details-header { display: flex; align-items: center; gap: 14px; margin-bottom: 18px; }
  .rm-details-header-icon {
    width: 44px; height: 44px; border-radius: 12px; flex-shrink: 0;
    background: #0d1433; color: #fff;
    display: flex; align-items: center; justify-content: center;
  }
  .rm-details-header h3 { font-family: 'Poppins', sans-serif; font-size: 16.5px; font-weight: 700; color: #0d1433; margin: 0; }
  .rm-details-header p { font-size: 12.5px; color: #8a93a8; margin: 2px 0 0; }
  .rm-details-hr { height: 1px; background: #eceff7; margin-bottom: 20px; }
  .rm-tier-footer {
    display: flex; align-items: center; justify-content: center; gap: 16px;
    background: #f6f8fb; border-top: 1px solid #eaedf4;
    padding: 20px 44px; border-radius: 0; flex-shrink: 0;
    box-sizing: border-box;
  }
  .rm-tier-footer-inner { display: flex; align-items: center; justify-content: space-between; gap: 16px; max-width: 1040px; width: 100%; flex-wrap: wrap; }
  .rm-tier-footer-note { display: flex; align-items: flex-start; gap: 10px; }
  .rm-tier-footer-note i { color: #8a93a8; margin-top: 2px; flex-shrink: 0; }
  .rm-tier-footer-note p { margin: 0; font-size: 12.5px; line-height: 1.5; color: #5b6577; }
  .rm-tier-footer-note p:first-child { color: #1a1f2e; font-weight: 600; }
  .rm-continue-btn {
    background: #f37c23; color: #fff; font-family: 'Poppins', sans-serif; font-weight: 700; font-size: 14.5px;
    padding: 14px 28px; border-radius: 50px; border: none; cursor: pointer;
    display: flex; align-items: center; gap: 8px; white-space: nowrap;
    transition: background 0.2s, transform 0.15s; flex-shrink: 0;
  }
  .rm-continue-btn:hover:not(:disabled) { background: #c55e10; transform: translateY(-1px); }
  .rm-continue-btn:disabled { opacity: 0.5; cursor: not-allowed; }
  .rm-tier-footer-dark {
    background: #0d1433; border-top: none;
    padding: 18px 44px; flex-shrink: 0; box-sizing: border-box;
  }
  .rm-tier-footer-dark-inner { display: flex; align-items: center; justify-content: space-between; gap: 18px; max-width: 1040px; width: 100%; margin: 0 auto; flex-wrap: wrap; }
  .rm-tfd-left { display: flex; align-items: center; gap: 14px; }
  .rm-tfd-icon {
    width: 42px; height: 42px; border-radius: 50%; flex-shrink: 0;
    background: rgba(255,255,255,0.08); color: #f37c23;
    display: flex; align-items: center; justify-content: center;
  }
  .rm-tfd-left span { display: block; font-size: 11px; color: rgba(255,255,255,0.5); text-transform: uppercase; letter-spacing: 0.5px; }
  .rm-tfd-left strong { display: block; font-size: 15px; color: #fff; font-family: 'Poppins', sans-serif; }
  .rm-tfd-amount span { display: block; font-size: 11px; color: rgba(255,255,255,0.5); text-transform: uppercase; letter-spacing: 0.5px; }
  .rm-tfd-amount strong { display: block; font-size: 17px; color: #f37c23; font-family: 'Poppins', sans-serif; }
  .rm-tfd-right { display: flex; align-items: center; gap: 18px; flex-wrap: wrap; }
  .rm-tfd-secure { display: flex; align-items: center; gap: 6px; font-size: 11px; color: rgba(255,255,255,0.5); }
  .rm-tfd-secure strong { color: rgba(255,255,255,0.75); }
  .rm-pay-card {
    background: #f6f8fb; border: 1.5px solid #eceff4; border-radius: 18px;
    padding: 22px 26px; margin-top: 26px;
    display: flex; align-items: center; justify-content: space-between; gap: 20px; flex-wrap: wrap;
  }
  .rm-pay-card-note { display: flex; align-items: flex-start; gap: 10px; }
  .rm-pay-card-note i { color: #1a1f2e; margin-top: 2px; flex-shrink: 0; }
  .rm-pay-card-note p { margin: 0; font-size: 12.5px; line-height: 1.5; color: #5b6577; }
  .rm-pay-card-note p:first-child { color: #1a1f2e; font-weight: 700; font-size: 13.5px; margin-bottom: 2px; }
  .rm-submit {
    background: #f37c23; color: #fff;
    font-family: 'Poppins', sans-serif; font-weight: 700; font-size: 14.5px;
    padding: 15px 26px; border-radius: 50px; border: none; cursor: pointer;
    display: flex; align-items: center; justify-content: center; gap: 10px;
    transition: background 0.2s, transform 0.15s; flex-shrink: 0; white-space: nowrap;
  }
  .rm-submit:hover:not(:disabled) { background: #c55e10; transform: translateY(-1px); }
  .rm-submit:disabled { opacity: 0.65; cursor: not-allowed; }
  .rm-trust-row { display: flex; align-items: center; justify-content: center; gap: 22px; flex-wrap: wrap; margin-top: 16px; }
  .rm-trust-item { display: flex; align-items: center; gap: 6px; font-size: 11.5px; color: #8a93a8; font-weight: 600; }
  .rm-trust-item i { color: #aab2c3; }
  @keyframes rm-spin { to { transform: rotate(360deg); } }
  .rm-spinner { width: 18px; height: 18px; border: 2.5px solid rgba(255,255,255,0.35); border-top-color: #fff; border-radius: 50%; animation: rm-spin 0.7s linear infinite; flex-shrink: 0; }
  .rm-upload-field { margin-top: 2px; }
  .rm-upload-box {
    border: 1.5px dashed #d4daea;
    border-radius: 12px;
    padding: 16px 18px;
    display: flex;
    align-items: center;
    gap: 14px;
    cursor: pointer;
    transition: border-color 0.2s, background 0.2s;
    background: #fafbfd;
  }
  .rm-upload-box:hover { border-color: #f37c23; background: #fff8f2; }
  .rm-upload-box.error { border-color: #e53e3e; background: #fff5f5; }
  .rm-upload-box.done { border-color: #00a000; background: #f0fff0; cursor: default; }
  .rm-upload-icon {
    width: 40px; height: 40px; border-radius: 10px; flex-shrink: 0;
    display: flex; align-items: center; justify-content: center;
    background: #fdebd6; color: #f37c23;
  }
  .rm-upload-box.done .rm-upload-icon { background: #ddf3dd; color: #00a000; }
  .rm-upload-box.error .rm-upload-icon { background: #fee2e2; color: #e53e3e; }
  .rm-upload-text { flex: 1; min-width: 0; }
  .rm-upload-text strong { display: block; font-size: 13.5px; color: #1a1f2e; }
  .rm-upload-text span { display: block; font-size: 11.5px; color: #8a93a8; margin-top: 2px; overflow: hidden; text-overflow: ellipsis; white-space: nowrap; }
  .rm-upload-remove {
    background: none; border: none; color: #aab2c3; cursor: pointer; padding: 6px; flex-shrink: 0; border-radius: 6px;
  }
  .rm-upload-remove:hover { color: #e53e3e; background: rgba(229,62,62,0.08); }
  .rm-upload-spinner { width: 18px; height: 18px; border: 2.5px solid #f0dfa0; border-top-color: #f37c23; border-radius: 50%; animation: rm-spin 0.7s linear infinite; flex-shrink: 0; }
  .rm-success { padding: 64px 32px; text-align: center; max-width: 580px; margin: 0 auto; }
  .rm-success-icon {
    width: 84px; height: 84px; border-radius: 50%;
    background: linear-gradient(135deg, #e6ffe6, #b2f7b2); border: 3px solid #00a000;
    display: flex; align-items: center; justify-content: center; margin: 0 auto 22px;
  }
  .rm-success-icon i { font-size: 42px; color: #00a000; }
  .rm-success h3 { font-family: 'Poppins', sans-serif; font-size: 1.4rem; font-weight: 800; color: #0d1433; margin: 0 0 10px; }
  .rm-success p { font-size: 14.5px; color: #5b6577; line-height: 1.6; margin: 0 0 6px; }
  .rm-success .ticket-id {
    display: inline-block; background: #fff5ec; border: 1.5px solid #f37c23; border-radius: 8px;
    padding: 9px 22px; font-family: 'Poppins', sans-serif; font-weight: 800; font-size: 1.15rem;
    color: #f37c23; margin: 14px 0 0; letter-spacing: 1px;
  }
  .rm-success .paid-pill {
    display: inline-flex; align-items: center; gap: 6px; background: #f0fff0; border: 1.5px solid #b2f7b2;
    color: #00a000; font-weight: 700; font-size: 12.5px; border-radius: 50px; padding: 6px 15px; margin-top: 12px;
  }
  .rm-success .rm-submit { margin-top: 30px; background: #0d1433; width: 100%; }
  .rm-success .rm-submit:hover { background: #1a2550; }
  .rm-fine { display: flex; align-items: center; justify-content: center; gap: 6px; font-size: 11px; color: #9daac5; text-align: center; margin-top: 14px; line-height: 1.5; }
  .rm-fine i { flex-shrink: 0; }
  @media (max-width: 1180px) and (min-width: 901px) {
    .rm-choice-list { grid-template-columns: 1fr 1fr; }
  }
  @media (max-width: 900px) {
    .rm-choice-list { grid-template-columns: 1fr; }
    .rm-tier-list.rm-tier-grid-2 { grid-template-columns: 1fr; }
    .rm-tier-feats-grid { grid-template-columns: 1fr; }
    .rm-stats-bar { flex-direction: column; align-items: stretch; }
    .rm-stats-items { justify-content: space-between; gap: 16px; }
    .rm-header p { max-width: 80%; }
    .rm-bg-watermark { width: 320px; height: 280px; opacity: 0.1; }
  }
    
  @media (max-width: 720px) {
    .rm-bg-watermark { display: none; }
    .rm-hero-wrap { margin: 14px auto 0; width: calc(100% - 24px); border-radius: 20px; min-height: 240px; }
    .rm-header { padding: 24px 18px 20px; }
    .rm-header h2 { font-size: 1.3rem; }
    .rm-header p { max-width: 100%; font-size: 13px; }
    .rm-header-badge { font-size: 9px; padding: 4px 11px; }
    .rm-hero-features { gap: 4px; flex-wrap: nowrap; justify-content: space-between; }
    .rm-hero-feature { padding: 0 2px; flex: 1 1 0; min-width: 0; }
    .rm-hero-feature-icon { width: 32px; height: 32px; }
    .rm-hero-feature strong { font-size: 11px; white-space: nowrap; }
    .rm-hero-feature small { font-size: 9px; white-space: nowrap; }
    .rm-hero-feature-divider { display: none; }
    .rm-hero-bg img { object-position: 65% 70%; }
    .rm-hero-pills { gap: 8px; }
    .rm-hero-pill { font-size: 11.5px; padding: 7px 12px; }
    .rm-meta-strip-light { margin: 16px 12px 4px; padding: 14px 8px; width: calc(100% - 24px); max-width: none; justify-content: center; flex-wrap: wrap; row-gap: 10px; }
  .rm-meta-item-light2 { padding: 4px 10px; gap: 6px; flex: 0 1 auto; min-width: 0; justify-content: center; }
    .rm-meta-item-light2-icon { width: 26px; height: 26px; }
   .rm-meta-item-light2 strong { font-size: 10.5px; white-space: nowrap; }
  .rm-meta-item-light2 small { font-size: 9px; white-space: nowrap; }
  .rm-meta-divider-v { display: none; }
  .rm-meta-strip-light .rm-meta-item-light2:last-child { flex-basis: 100%; }
    .rm-body { padding: 18px 18px 22px; }
    .rm-field-row { grid-template-columns: 1fr; gap: 0; }
    .rm-tier-card {
  padding: 16px;
  gap: 0;
  position: relative;
}
.rm-tier-radio {
  position: absolute;
  top: 16px;
  left: 16px;
  margin: 0;
}
.rm-tier-icon {
  position: absolute;
  top: 14px;
  left: 48px;
  margin: 0;
}
.rm-tier-main {
  width: 100%;
}
.rm-tier-top {
      display: flex;
      flex-wrap: wrap;
      align-items: center;
      justify-content: space-between;
      gap: 6px 10px;
      padding-right: 0;
      padding-left: 110px;   /* radio/icon ke peeche na chhupe isliye */
      min-height: 50px;
    }
      .rm-tier-title-col {
      flex: 1 1 auto;
      min-width: 0;
    }

 .rm-tier-price-wrap {
      display: contents;   /* iske bachche seedha rm-tier-top ke flex row mein aa jaate hain */
    }
      .rm-tier-price {
      order: 1;
      white-space: nowrap;
      flex-shrink: 0;
    }
    .rm-tier-price-note {
      order: 3;
      width: 100%;         /* "Inclusive of taxes" apni nayi line mein chala jaayega */
    }
    .rm-tier-select-btn {
      order: 4;
      margin-left: auto;
    }
.rm-tier-urgency,
.rm-tier-tagline,
.rm-tier-feats-list,
.rm-tier-feats-dots,
.rm-tier-feats-grid {
  margin-left: 0;   /* ye ab card ke left padding se hi shuru honge, koi extra gap nahi */
}
    .rm-tier-footer, .rm-tier-footer-dark { padding: 16px 18px; }
    .rm-tier-footer-inner, .rm-tier-footer-dark-inner { flex-direction: column; align-items: stretch; }
    .rm-tfd-right { justify-content: space-between; }
    .rm-continue-btn { justify-content: center; }
    .rm-choice-card { padding: 18px; }
    .rm-choice-feats-row {
      flex-direction: column;
      align-items: stretch;
      flex-wrap: nowrap;
      gap: 14px;
    }
    .rm-choice-feats {
      display: grid !important;
      grid-template-columns: 1fr 1fr;
      grid-template-rows: auto auto;
      gap: 0;
      width: 100%;
      flex: none;
    }
    .rm-choice-feat {
      flex: none;
      min-width: 0;
      padding: 12px 6px;
      border-right: 1px solid #e2e5f0;
      border-bottom: 1px solid #e2e5f0;
    }
    .rm-choice-feat:nth-child(2n) { border-right: none; }
    .rm-choice-feat:nth-child(n+3) { border-bottom: none; }
    .rm-choice-arrow-btn { align-self: flex-end; }
    .rm-selected-card { flex-direction: column; align-items: flex-start; }
    .rm-selected-card-right { width: 100%; justify-content: space-between; }
    .rm-pay-card { flex-direction: column; align-items: stretch; }
    .rm-submit { width: 100%; }
    .rm-stats-bar {
      display: flex;
      flex-direction: column;
      gap: 0;
      padding: 0;
      border-radius: 16px;
      overflow: hidden;
    }
    .rm-stats-items {
      display: grid !important;
      grid-template-columns: 1fr 1fr;
      width: 100%;
    }
    .rm-stat {
      flex: none;
      min-width: 0;
      padding: 14px 12px;
      border-right: 1px solid rgba(255,255,255,0.14);
      border-bottom: 1px solid rgba(255,255,255,0.14);
    }
    .rm-stat:nth-child(2n) { border-right: none; }
    .rm-stat:nth-child(n+3) { border-bottom: none; }
    .rm-stats-cta {
      width: 100%;
      border-radius: 0;
      padding: 16px;
      text-align: center;
      white-space: normal;
    }
    .rm-trust-row { gap: 12px; }
    .rm-success { padding: 44px 20px; }
  }
  @media (max-width: 420px) {
    .rm-header h2 { font-size: 1.12rem; }
    .rm-hero-wrap { min-height: 210px; }
    .rm-hero-feature strong { font-size: 10.5px; }
    .rm-hero-feature small { font-size: 8.5px; }
    .rm-choice-tag { font-size: 9px; padding: 3px 10px; }
    .rm-choice-main h3 { font-size: 16px; }
    .rm-choice-icon, .rm-choice-icon-wrap { width: 48px; height: 48px; }
    .rm-tier-price { font-size: 18px; }
    .rm-tier-name { font-size: 15.5px; }
  }
`;

/* ============================================================
   RAZORPAY SCRIPT LOADER
   ============================================================ */
function useRazorpayScript() {
  const [ready, setReady] = useState(typeof window !== "undefined" && !!window.Razorpay);
  useEffect(() => {
    if (window.Razorpay) { setReady(true); return; }
    const existing = document.querySelector(`script[src="${RAZORPAY_CHECKOUT_SRC}"]`);
    if (existing) {
      existing.addEventListener("load", () => setReady(true));
      return;
    }
    const script = document.createElement("script");
    script.src = RAZORPAY_CHECKOUT_SRC;
    script.async = true;
    script.onload = () => setReady(true);
    script.onerror = () => setReady(false);
    document.body.appendChild(script);
  }, []);
  return ready;
}

/* ============================================================
   TIER FEATURE LIST (renders the right layout per tier.featureStyle)
   All tiers now use the single-column checkmark list layout.
   ============================================================ */
function TierFeatures({ tier }) {
  return (
    <div className="rm-tier-feats-list">
      {tier.features.map((f) => (
        <span className="rm-fl-item" key={f}><Icon name="fa-check" size={14} style={{ color: tier.accent }} />{f}</span>
      ))}
    </div>
  );
}

/* ============================================================
   TIER CARD (used by Event Registration, Startup Pitching, and Audience Registration)
   ============================================================ */
function TierCard({ tier, selected, onSelect }) {
  const { remaining } = useSlotAvailability(tier.key, tier.totalSlots);
  const soldOut = !!tier.forceSoldOut || (!!tier.totalSlots && remaining <= 0);
  return (
    <div
      className={`rm-tier-card${selected ? " selected" : ""}${soldOut ? " soldout" : ""}`}
      style={{ "--tier-accent": tier.accent, "--tier-soft": `${tier.accent}14` }}
      onClick={() => { if (!soldOut) onSelect(tier.key); }}
      role="radio"
      aria-checked={selected}
      aria-disabled={soldOut}
      tabIndex={soldOut ? -1 : 0}
      onKeyDown={(e) => { if (!soldOut && (e.key === "Enter" || e.key === " ")) onSelect(tier.key); }}
    >
      <div className="rm-tier-radio" style={selected && !soldOut ? { borderColor: tier.accent } : undefined}>
        <div className="rm-tier-radio-dot" style={{ background: tier.accent }} />
      </div>
      <div className="rm-tier-icon" style={{ background: tier.soft }}>
        <Icon name={tier.icon} size={22} style={{ color: tier.accent }} />
      </div>
      <div className="rm-tier-main">
        <div className="rm-tier-top">
          <div className="rm-tier-title-col">
            <span className="rm-tier-name">
              {tier.label}
              {tier.highlight && !soldOut && (
                <span className="rm-tier-badge" style={{ background: `${tier.accent}22`, color: tier.accent, border: `1px solid ${tier.accent}44` }}>
                  Best Value
                </span>
              )}
              {soldOut && (
                <span className="rm-tier-badge" style={{ background: "#fee2e2", color: "#e53e3e", border: "1px solid #fca5a5" }}>
                  Sold Out
                </span>
              )}
            </span>
          </div>
          <span className="rm-tier-price-wrap">
            <span className="rm-tier-price" style={{ color: tier.accent }}>₹{tier.price.toLocaleString("en-IN")}</span>
            <span className="rm-tier-price-note">Inclusive of taxes</span>
            {!soldOut && (
              selected ? (
                <span className="rm-tier-select-btn" style={{ background: tier.accent, color: "#fff" }}>
                  <Icon name="fa-check" size={12} />Selected
                </span>
              ) : (
                <span
                  className="rm-tier-select-btn"
                  style={{ background: "#fff", color: tier.accent, border: `1.5px solid ${tier.accent}55` }}
                  onClick={(e) => { e.stopPropagation(); onSelect(tier.key); }}
                >
                  Select Pass
                </span>
              )
            )}
          </span>
        </div>
        {tier.urgencyNote && (
          <div className="rm-tier-urgency">
            <span className="rm-tier-urgency-icon"><Icon name="fa-clock" size={11} /></span>
            {tier.urgencyNote}
          </div>
        )}
        {tier.tagline && <p className="rm-tier-tagline" style={{ marginBottom: 12 }}>{tier.tagline}</p>}
        <TierFeatures tier={tier} />
      </div>
    </div>
  );
}

/* ============================================================
   EXPORTS — everything the flow/root component (RegisterModal.jsx) needs
   ============================================================ */
export {
  API_BASE,
  RAZORPAY_KEY_ID,
  EVENT_TIER_CONFIGS,
  PITCH_TIER_CONFIGS,
  AUDIENCE_TIER_CONFIGS,
  FIELD_CONFIGS,
  INITIAL,
  Icon,
  HeroBackdrop,
  HeroMetaPills,
  MetaCardLight,
  Divider,
  modalStyles,
  useRazorpayScript,
  TierCard,
};